export function downsampleBuffer(buffer, originSampleRate, destSampleRate) {
  if (destSampleRate == originSampleRate) {
    return buffer
  }
  if (destSampleRate > originSampleRate) {
    throw 'downsampling rate show be smaller than original sample rate'
  }
  var sampleRateRatio = originSampleRate / destSampleRate
  var newLength = Math.round(buffer.length / sampleRateRatio)
  var result = new Float32Array(newLength)
  var offsetResult = 0
  var offsetBuffer = 0
  while (offsetResult < result.length) {
    var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio)
    // Use average value of skipped samples
    var accum = 0,
      count = 0
    for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
      accum += buffer[i]
      count++
    }
    result[offsetResult] = accum / count
    // Or you can simply get rid of the skipped samples:
    // result[offsetResult] = buffer[nextOffsetBuffer];
    offsetResult++
    offsetBuffer = nextOffsetBuffer
  }
  return result
}

export function downloadBlob(blob, name) {
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = name
  document.body.appendChild(link)
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  )
  document.body.removeChild(link)
}

export function concatFloat32Arrays(arrays) {
  const totalLength = arrays.reduce((acc, arr) => acc + arr.length, 0)
  const result = new Float32Array(totalLength)
  let offset = 0
  for (const arr of arrays) {
    result.set(arr, offset)
    offset += arr.length
  }
  return result
}

export function float32ToInt16PCM(floatSamples) {
  const buffer = new Int16Array(floatSamples.length)
  for (let i = 0; i < floatSamples.length; i++) {
    const sample = Math.max(-1, Math.min(1, floatSamples[i]))
    buffer[i] = sample < 0 ? sample * 0x8000 : sample * 0x7fff
  }
  return buffer
}

export function int16PCMToFloat32(pcmSamples) {
  const float32Samples = new Float32Array(pcmSamples.length)
  for (let i = 0; i < pcmSamples.length; i++) {
    float32Samples[i] = pcmSamples[i] / 32768
  }
  return float32Samples
}
